import type { Diagnosis } from "../flasher/errors";
import { AlertIcon, CloseIcon, InfoIcon } from "./Icons";

interface Props {
  diagnosis: Diagnosis;
  onDismiss: () => void;
}

/**
 * The failure report. Deliberately verbose: this panel is the difference
 * between a user retrying blindly and a user knowing to hold the BOOT button.
 */
export function DiagnosisPanel({ diagnosis, onDismiss }: Props) {
  const isNotice = diagnosis.severity === "notice";

  return (
    <div className={`diagnosis${isNotice ? " diagnosis--notice" : ""}`} role="alert">
      <div className="diagnosis__header">
        <span className="diagnosis__glyph">
          {isNotice ? <InfoIcon size={19} /> : <AlertIcon size={19} />}
        </span>
        <div className="diagnosis__title">
          <h3 style={{ fontSize: "15.5px" }}>{diagnosis.title}</h3>
          <div className="diagnosis__code">{diagnosis.code}</div>
        </div>
        <button className="btn btn--ghost" onClick={onDismiss} aria-label="Dismiss this message">
          <CloseIcon size={15} />
        </button>
      </div>

      <div className="diagnosis__body">
        <p className="diagnosis__para">{diagnosis.what}</p>
        <p className="diagnosis__para">
          <strong>Why this happens: </strong>
          {diagnosis.why}
        </p>

        <div>
          <div className="diagnosis__section-label">Try these in order</div>
          <ol className="fixes">
            {diagnosis.fixes.map((fix) => (
              <li key={fix}>
                <span>{fix}</span>
              </li>
            ))}
          </ol>
        </div>

        {diagnosis.technical && (
          <details className="diagnosis__technical">
            <summary>Show the original error message</summary>
            <pre>{diagnosis.technical}</pre>
          </details>
        )}
      </div>
    </div>
  );
}
